import TemplateContents from './TemplateContents';
import {gsap} from "gsap";

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
  }

  setVars() {
    super.setVars();
  }

  setDom() {
    super.setDom();

    this.logo = document.querySelector('header .logo');
    this.logoLink = document.querySelector('header .logo a');

    if (this.logoLink && document.documentElement.lang === 'en') {
      this.logoLink.href = 'https://www.flypeach.com/en';
    }

    this.menuDom = document.querySelector('header .menu');
    this.menuTitDom = document.querySelector('header .menu .tit');
    this.menuBG = document.querySelector('header .menu_bg');
    this.menuUl = document.querySelector('header .menu ul');
    this.menuLiAll = document.querySelectorAll('header .menu ul li');

    this.section1 = document.querySelector('main.top .section1');
    this.section2 = document.querySelector('main.top .section2');
    this.section3 = document.querySelector('main.top .section3');
    this.section4_5 = document.querySelector('main.top .section4 .chunk6');
  }

  initEvents() {
    super.initEvents();

    this.menuTitDom.addEventListener('click', (event) => {
      if(this.menuDom.classList.contains('open')){
        this.closeMenu();
      }else{
        this.openMenu();
      }
    });

    this.menuBG.addEventListener('click', (event) => {
      this.closeMenu();
    });

    for( let i = 0, len = this.menuLiAll.length; i < len; i++ ){
      let item = this.menuLiAll[i];
      item.addEventListener('click', (event) => {
        this.anchorScroll(i);
      });
    }
  }

  anchorScroll(id){
    let targetY;
    if(id === 0) targetY = 0;
    else if(id === 1) targetY = this.section1.getBoundingClientRect().top + this.pack.scrollY;
    else if(id === 2) targetY = this.section2.getBoundingClientRect().top + this.pack.scrollY;
    else if(id === 3) targetY = this.section4_5.getBoundingClientRect().top + this.pack.scrollY;

    this.pack.anchorScroll(targetY);
    this.closeMenu();
  }

  openMenu(){
    this.menuDom.classList.add('open');
    this.menuBG.classList.add('open');

    gsap.delayedCall(.25, ()=>{
      this.menuUl.classList.add('open');
    });
  }

  closeMenu(){
    this.menuUl.classList.remove('open');
    this.menuBG.classList.remove('open');

    gsap.delayedCall(.25, ()=>{
      this.menuDom.classList.remove('open');
    });
  }

  start() {}

  scrollHandler() {
    if (!this.logo || !this.section3) return;

    const logoRect = this.logo.getBoundingClientRect();
    const section3Rect = this.section3.getBoundingClientRect();

    const isOverlapping =
      section3Rect.top <= logoRect.bottom && section3Rect.bottom >= logoRect.top;

    this.logo.classList.toggle('ivory', isOverlapping);
  }

  enterframe() {}

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
  }
}
